var _defs, _rect, _path, _polygon, _polygon2, _path2, _path3, _path4, _path5, _polygon3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataAnalyticsMonochromatic(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 998.7 926.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 441.62,
    y1: 387.54,
    x2: 900.64,
    y2: 1267.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 514.91,
    y1: -27.08,
    x2: 522.19,
    y2: 967.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 214.12,
    y1: 106.48,
    x2: 1946.39,
    y2: 2122.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 395.7,
    y1: 389.67,
    x2: 701.72,
    y2: 968.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 456.74,
    y1: 357.43,
    x2: 762.76,
    y2: 936.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 417.41,
    y1: 219.53,
    x2: 849.12,
    y2: 452.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 580.71,
    y1: 312.56,
    x2: 1012.41,
    y2: 545.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 163.37,
    y1: 266.12,
    x2: 595.07,
    y2: 499.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 269.93,
    y1: 315.76,
    x2: 701.63,
    y2: 548.91,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5. ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M268.91,963c75.85,34.09,167.58,30.48,240.51-9.46,22.64-12.41,43.63-28.11,67.73-37.38,58.41-22.45,123.84-3.73,186.28-7.79,105.44-6.85,198-80.6,251.52-171.7s73.67-197.78,85.28-302.8c13-117.42,8.1-255.17-85.18-327.66C940.48,48.24,835.35,54,742.76,72.57S555,119.68,463.13,98C430,90.21,398,75.94,364,74.27c-60.64-3-116.6,35-155.56,81.6-66.85,79.92-96.1,185.93-100.84,290-4.75,104.44,13.74,209.44,16.52,313.35C126.54,850.25,185.26,925.36,268.91,963Z",
    transform: "translate(-106.82 -59.7)",
    fill: "#68e1fd",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 254.32,
    y: 164.26,
    width: 525.79,
    height: 574.55,
    rx: 59.7,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M435.45,798.51l74.68-68.28s102.92,73.49,201.28,8.06,101.61-193.75,56.73-243-44.33-14.21-44.33-14.21,70,193.45-82,212.86-166.73-23.84-166.73-23.84L382.63,798.51Z",
    transform: "translate(-106.82 -59.7)",
    fill: "url(#linear-gradient)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "254.32 342.05 340.18 392.66 484.92 293.48 644.97 400.34 780.11 275.53 780.11 234.02 642.85 352.74 486.21 263.88 338.14 343.96 254.32 314.98 254.32 342.05",
    fill: "url(#linear-gradient-2)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "136.84 387.37 127.19 375.23 231.79 292.08 338.14 343.96 485.84 245.49 650.31 345.72 816.55 184.52 827.34 195.65 652.49 365.2 486.21 263.88 339.33 361.8 233.79 310.31 136.84 387.37",
    fill: "#68e1fd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M317.85,807.73a25.4,25.4,0,0,0,0,35.94h0a25.4,25.4,0,0,0,35.94,0L512.85,691.21a25.42,25.42,0,0,0,0-35.94h0a25.42,25.42,0,0,0-35.94,0Z",
    transform: "translate(-106.82 -59.7)",
    fill: "#68e1fd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M430.73,562.85A175.44,175.44,0,1,0,606.17,387.4,175.44,175.44,0,0,0,430.73,562.85Zm44.32,0A131.12,131.12,0,1,1,606.17,694,131.11,131.11,0,0,1,475.05,562.85Z",
    transform: "translate(-106.82 -59.7)",
    fill: "#68e1fd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M430.73,562.85A175.44,175.44,0,1,0,606.17,387.4,175.44,175.44,0,0,0,430.73,562.85Zm44.32,0A131.12,131.12,0,1,1,606.17,694,131.11,131.11,0,0,1,475.05,562.85Z",
    transform: "translate(-106.82 -59.7)",
    fill: "url(#linear-gradient-3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M417.25,550.12A175.45,175.45,0,1,0,592.69,374.68,175.44,175.44,0,0,0,417.25,550.12Zm44.33,0A131.12,131.12,0,1,1,592.69,681.23,131.11,131.11,0,0,1,461.58,550.12Z",
    transform: "translate(-106.82 -59.7)",
    fill: "#68e1fd"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "827.63 275.53 812.16 274.46 817.72 193.93 728.16 208.37 725.69 193.06 834.53 175.52 827.63 275.53",
    fill: "#68e1fd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 413.7,
    y: 519.22,
    width: 28.87,
    height: 40.22,
    fill: "#68e1fd"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 449.31,
    y: 477.5,
    width: 28.87,
    height: 81.94,
    fill: "#68e1fd"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 484.92,
    y: 509.55,
    width: 28.87,
    height: 49.89,
    fill: "#68e1fd"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 520.52,
    y: 451.54,
    width: 28.87,
    height: 107.9,
    fill: "#68e1fd"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 449.31,
    y: 477.5,
    width: 28.87,
    height: 81.94,
    fill: "url(#linear-gradient-4)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 520.52,
    y: 451.54,
    width: 28.87,
    height: 107.9,
    fill: "url(#linear-gradient-5)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 556.13,
    y: 421.4,
    width: 28.87,
    height: 138.04,
    fill: "#68e1fd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 485.88,
    cy: 256.51,
    r: 22.49,
    fill: "#68e1fd"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 485.88,
    cy: 256.51,
    r: 22.49,
    fill: "url(#linear-gradient-6)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 649.17,
    cy: 349.54,
    r: 22.49,
    fill: "#68e1fd"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 649.17,
    cy: 349.54,
    r: 22.49,
    fill: "url(#linear-gradient-7)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 231.83,
    cy: 303.1,
    r: 22.49,
    fill: "#68e1fd"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 231.83,
    cy: 303.1,
    r: 22.49,
    fill: "url(#linear-gradient-8)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.39,
    cy: 352.74,
    r: 22.49,
    fill: "#68e1fd"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.39,
    cy: 352.74,
    r: 22.49,
    fill: "url(#linear-gradient-9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataAnalyticsMonochromatic);
export default __webpack_public_path__ + "static/media/data_analytics__monochromatic.59f6761bc760e01ce50f8ec39d506ce7.svg";
export { ForwardRef as ReactComponent };